import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ' +
    'disabled:pointer-events-none disabled:opacity-50', {
    variants: {
        variant: {
            primary: 'bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm',
            secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
            outline: 'border border-input bg-background hover:bg-muted hover:text-foreground',
            ghost: 'hover:bg-muted hover:text-foreground',
            destructive: 'bg-red-600 text-white hover:bg-red-700 shadow-sm',
            link: 'text-primary underline-offset-4 hover:underline',
        },
        size: {
            sm: 'h-8 px-3 text-xs',
            md: 'h-9 px-4',
            lg: 'h-11 px-6',
            icon: 'h-9 w-9',
        },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
});
export function Button({ className, variant, size, loading, leftIcon, rightIcon, children, disabled, ...props }) {
    return (_jsxs("button", { ...props, disabled: disabled || loading, className: cn(buttonVariants({ variant, size }), className), children: [loading ? (_jsx("span", { className: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" })) : leftIcon, children, rightIcon] }));
}
export { buttonVariants };
